module.exports = __webpack_public_path__ + "img/relaxing-music.d6cf9110.png";